module.exports = __webpack_public_path__ + "img/shield.9bbc540c.svg";